import React from 'react';
import { useIntl } from 'react-intl';

import ActionButton from 'components/widgets/ActionButton/ActionButton';

function GoBackErrorButton({
  isPendingBack,
  isDisabled,
  goBackDefaultMessage,
  goBackTranslationId,
  checkConnectionTimer,
  resolveBack,
}: {
  isPendingBack: boolean;
  isDisabled: boolean;
  goBackDefaultMessage: string | undefined;
  checkConnectionTimer: number | undefined;
  goBackTranslationId: string | undefined;
  resolveBack: () => void;
}) {
  const intl = useIntl();

  if (checkConnectionTimer !== undefined || !goBackTranslationId) {
    return null;
  }

  const buttonLabel = intl.formatMessage({ defaultMessage: goBackDefaultMessage, id: goBackTranslationId });

  return (
    <ActionButton title={buttonLabel} isPending={isPendingBack} onClick={resolveBack} disabled={isDisabled} />
  );
}

export default GoBackErrorButton;
